export enum SaveMode {
  SAVE_CONTINUE = 'SAVE_CONTINUE',
  SAVE_FINISH = 'SAVE_FINISH'
}
